<template>
  <md-field :class="validationClass">
    <label for="estoqueItem_precoMinimo">Custo Minimo</label>
      <md-input 
      type="text"
      required
      name="estoqueItem_precoMinimo" 
      id="estoqueItem_precoMinimo" 
      :disabled="sending"
      ref="inputRef"/>
      <span class="md-helper-text">Insira o preço minimo por unidade de medida</span>
      <span class="md-error" v-if="requiredValidation">Selecione a unidade medida para este item</span>
    </md-field>
</template>

<script>
import { watch } from '@vue/composition-api'
import { useCurrencyInput } from 'vue-currency-input'

export default {
  name: 'PrecoMinimo',
  props: {
    sending: Boolean,
    validationClass: Object,
    requiredValidation: Boolean,
    value: Number, // Vue 2: value
    options: Object
  },
  setup(props) {
    const { inputRef, setValue } = useCurrencyInput(props.options)

    watch(() => props.value, (value) => {
      setValue(value)
    })

    return { inputRef }
  }
}
</script>